import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import { Doughnut, Bar } from "react-chartjs-2";
import { Progress } from "reactstrap";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";
const { formatarReal } = require("../../utils");
am4core.useTheme(am4themes_dataviz);
am4core.useTheme(am4themes_animated);

const options = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: ["#309A85", "#e0d9d9"],
      hoverBackgroundColor: ["#309A85", "#e0d9d9"],
    },
  ],
};

const dataGrafico = {
  labels: [],
  datasets: [
    {
      label: "Valor total de pedidos",
      backgroundColor: "#309A85",
      borderColor: "#309A85",
      borderWidth: 1,
      hoverBackgroundColor: "#309A85",
      hoverBorderColor: "#309A85",
      data: [],
    },
  ],
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

class Dashboard extends Component {
  constructor() {
    super();
    this.toggleAba = this.toggleAba.bind(this);
    this.onChangePeriodoPedido = this.onChangePeriodoPedido.bind(this);
    this.onChangePeriodoOrcamento = this.onChangePeriodoOrcamento.bind(this);
    this.loadTotalizadoresPedido = this.loadTotalizadoresPedido.bind(this);
    this.loadTotalizadoresOrcamento =
      this.loadTotalizadoresOrcamento.bind(this);
    this.loadMeta = this.loadMeta.bind(this);
    this.loadPedidos = this.loadPedidos.bind(this);
    this.loadCarteiraClientes = this.loadCarteiraClientes.bind(this);
    this.setarDadosLocalStorage = this.setarDadosLocalStorage.bind(this);
    this.iniciaChartCarteiraClientes =
      this.iniciaChartCarteiraClientes.bind(this);
    this.iniciaGraficoMeta = this.iniciaGraficoMeta.bind(this);
    this.iniciaGraficoPedidos = this.iniciaGraficoPedidos.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);
    this.state = {
      abaAtiva: "pedido", //orcamento
      periodoPedido: "mesAtual", //mesAnterior
      periodoOrcamento: "mesAtual", //mesAnterior
      valorTotalPedido: 0,
      totalPedidos: 0,
      valorTotalOrcamento: 0,
      totalOrcamentos: 0,
      executaTotalizadorOrcamento: true,
      exibirGraficoMeta: false,
      optionsGrafico: options,
      periodo: "",
      meta: 0,
      metaRealizada: 0,
      dataGrafico: dataGrafico,
      totalClientesAtendidos: 0,
      totalClientes: 0,
      porcentagemAtendidos: 0,
      totalOrcamentosCancelados: 0,
      ticketMedioPedidos: 0,
      ticketMedioOrcamentos: 0,
      dataGraficoCarteiraClientes: [],
      porcentagemGraficoMeta: 0,
      dataGraficoPedidos: [],
      optionsfiltro: [],
    };
  }

  async componentDidMount() {
    this.setarDadosLocalStorage();
    this.loadTotalizadoresPedido();
    this.loadMeta();
    this.loadPedidos();
    this.loadCarteiraClientes();
    this.iniciaChartCarteiraClientes();
    this.iniciaGraficoMeta();
    this.iniciaGraficoPedidos();
    this.verificaAutenticacao();
  }

  toggleAba(abaAlterar) {
    this.setState({ abaAtiva: abaAlterar }, () => {
      if (
        abaAlterar === "orcamento" &&
        this.state.executaTotalizadorOrcamento
      ) {
        this.loadTotalizadoresOrcamento();
      }
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  onChangePeriodoPedido(e) {
    this.setState({ periodoPedido: e.target.value }, () => {
      this.loadTotalizadoresPedido();
    });
  }

  onChangePeriodoOrcamento(e) {
    this.setState({ periodoOrcamento: e.target.value }, () => {
      this.loadTotalizadoresOrcamento();
    });
  }

  async loadTotalizadoresPedido() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/dashboard/pedidos-totalizadores?periodo=${
          this.state.periodoPedido
        }`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;
        let valorTotalData = data.valorTotal;
        let totalPedidosData = data.totalPedidos;
        let ticketMedioPedidos = 0;

        if (valorTotalData > 0) {
          ticketMedioPedidos = parseFloat(
            (valorTotalData / totalPedidosData).toFixed(2)
          );
        }

        this.setState(
          {
            valorTotalPedido: valorTotalData,
            totalPedidos: totalPedidosData,
            ticketMedioPedidos: ticketMedioPedidos,
          },
          () => {
            localStorage.setItem(
              "valorTotalPedido",
              this.state.valorTotalPedido
            );
            localStorage.setItem("totalPedidos", this.state.totalPedidos);
            this.loadCarteiraClientes();
            this.loadMeta();
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadTotalizadoresOrcamento() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/dashboard/orcamentos-totalizadores?periodo=${
          this.state.periodoOrcamento
        }`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;
        let valorTotalData = data.valorTotal;
        let totalOrcamentosData = data.totalPedidos;
        let ticketMedioOrcamentos = 0;

        if (valorTotalData > 0) {
          ticketMedioOrcamentos = parseFloat(
            (valorTotalData / totalOrcamentosData).toFixed(2)
          );
        }
        this.setState({
          valorTotalOrcamento: valorTotalData,
          totalOrcamentos: totalOrcamentosData,
          executaTotalizadorOrcamento: false,
          totalOrcamentosCancelados: data.totalCancelados,
          ticketMedioOrcamentos,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadMeta() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/dashboard/meta`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;

        if (data.exibirGraficoMeta) {
          let options = this.state.optionsGrafico;
          options.labels = [];
          options.datasets[0].data = [];

          options.labels.push(`Realizada: ${data.realizada}%`);
          options.labels.push(`Não realizada: ${data.naoRealizada}%`);

          options.datasets[0].data.push(data.realizada);
          options.datasets[0].data.push(data.naoRealizada);

          this.setState(
            {
              optionsGrafico: options,
              periodo: data.periodo,
              meta: data.meta,
              metaRealizada: data.metaRealizada,
              exibirGraficoMeta: true,
              porcentagemGraficoMeta: data.realizada,
            },
            () => {
              localStorage.setItem(
                "optionsGrafico",
                JSON.stringify({
                  labels: options.labels,
                  datasets: options.datasets[0].data,
                })
              );
              localStorage.setItem("periodo", this.state.periodo);
              localStorage.setItem("meta", this.state.meta);
              localStorage.setItem("metaRealizada", this.state.metaRealizada);
              localStorage.setItem(
                "exibirGraficoMeta",
                this.state.exibirGraficoMeta
              );
              this.chart2.dispose();
              this.iniciaGraficoMeta();
            }
          );
        } else {
          this.setState({ exibirGraficoMeta: false });
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadPedidos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/dashboard/historico-pedidos`,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;
        let grafico = this.state.dataGrafico;

        grafico.labels = [];
        grafico.datasets[0].data = [];

        for (let item of data.historicoPedidos) {
          grafico.labels.push(item.mes);
          grafico.datasets[0].data.push(item.valorTotal);
        }

        let dataGraficoPedidos = this.state.dataGraficoPedidos;

        for (let item of data.historicoPedidos) {
          grafico.labels.push(item.mes);
          grafico.datasets[0].data.push(item.valorTotal);

          dataGraficoPedidos.push({
            month: item.mes,
            value: item.valorTotal,
            data: item.data,
          });
        }

        this.setState(
          {
            dataGrafico: grafico,
            dataGraficoPedidos,
          },
          () => {
            localStorage.setItem(
              "dataGrafico",
              JSON.stringify({
                labels: grafico.labels,
                datasets: grafico.datasets[0].data,
              })
            );
            this.chart3.dispose();
            this.iniciaGraficoPedidos();
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  async loadCarteiraClientes() {
    let periodo = { periodo: this.state.periodoPedido };
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/dashboard/carteira-clientes`,
        periodo,
        this.props.parameters()
      )
      .then((response) => {
        const data = response.data;
        let dataGraficoCarteiraClientes = [];
        dataGraficoCarteiraClientes.push({
          type: `Atendidos(${data.totalClientesAtendidos})`,
          value: data.totalClientesAtendidos,
          color: am4core.color("#dc3545"),
        });
        dataGraficoCarteiraClientes.push({
          type: `Não atendidos(${
            data.totalClientes - data.totalClientesAtendidos
          })`,
          value: data.totalClientes - data.totalClientesAtendidos,
          color: am4core.color("#e9ecef"),
        });

        this.setState(
          {
            totalClientesAtendidos: data.totalClientesAtendidos,
            totalClientes: data.totalClientes,
            porcentagemAtendidos: data.porcentagemAtendidos,
            dataGraficoCarteiraClientes,
          },
          () => {
            localStorage.setItem(
              "totalClientesAtendidos",
              this.state.totalClientesAtendidos
            );
            localStorage.setItem("totalClientes", this.state.totalClientes);
            localStorage.setItem(
              "porcentagemAtendidos",
              this.state.porcentagemAtendidos
            );
            this.chart.dispose();
            this.iniciaChartCarteiraClientes();
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  setarDadosLocalStorage() {
    let valorTotalPedido = this.state.valorTotalPedido;
    let totalPedidos = this.state.totalPedidos;
    let exibirGraficoMeta = this.state.exibirGraficoMeta;
    let optionsGrafico = this.state.optionsGrafico;
    let periodo = this.state.periodo;
    let meta = this.state.meta;
    let metaRealizada = this.state.metaRealizada;
    let dataGrafico = this.state.dataGrafico;
    let totalClientesAtendidos = this.state.totalClientesAtendidos;
    let totalClientes = this.state.totalClientes;
    let porcentagemAtendidos = this.state.porcentagemAtendidos;

    let valorTotalPedidoStorage = localStorage.getItem("valorTotalPedido");
    let totalPedidosStorage = localStorage.getItem("totalPedidos");
    let exibirGraficoMetaStorage = localStorage.getItem("exibirGraficoMeta");
    let optionsGraficoStorage = localStorage.getItem("optionsGrafico");
    let periodoStorage = localStorage.getItem("periodo");
    let metaStorage = localStorage.getItem("meta");
    let metaRealizadaStorage = localStorage.getItem("metaRealizada");
    let dataGraficoStorage = localStorage.getItem("dataGrafico");
    let totalClientesAtendidosStorage = localStorage.getItem(
      "totalClientesAtendidos"
    );
    let totalClientesStorage = localStorage.getItem("totalClientes");
    let porcentagemAtendidosStorage = localStorage.getItem(
      "porcentagemAtendidos"
    );

    if (valorTotalPedidoStorage !== null) {
      valorTotalPedido = parseFloat(valorTotalPedidoStorage);
    }

    if (totalPedidosStorage !== null) {
      totalPedidos = parseFloat(totalPedidosStorage);
    }

    if (exibirGraficoMetaStorage !== null) {
      exibirGraficoMeta = exibirGraficoMetaStorage === "true" ? true : false;
    }

    if (optionsGraficoStorage !== null) {
      optionsGraficoStorage = JSON.parse(optionsGraficoStorage);
      optionsGrafico.labels = optionsGraficoStorage.labels;
      optionsGrafico.datasets[0].data = optionsGraficoStorage.datasets;
    }

    if (periodoStorage !== null) {
      periodo = periodoStorage;
    }

    if (metaStorage !== null) {
      meta = parseFloat(metaStorage);
    }

    if (metaRealizadaStorage !== null) {
      metaRealizada = parseFloat(metaRealizadaStorage);
    }

    if (dataGraficoStorage !== null) {
      dataGraficoStorage = JSON.parse(dataGraficoStorage);
      dataGrafico.labels = dataGraficoStorage.labels;
      dataGrafico.datasets[0].data = dataGraficoStorage.datasets;
    }

    if (totalClientesAtendidosStorage !== null) {
      totalClientesAtendidos = totalClientesAtendidosStorage;
    }

    if (totalClientesStorage !== null) {
      totalClientes = totalClientesStorage;
    }

    if (porcentagemAtendidosStorage !== null) {
      porcentagemAtendidos = porcentagemAtendidosStorage;
    }

    this.setState({
      valorTotalPedido,
      totalPedidos,
      exibirGraficoMeta,
      optionsGrafico,
      periodo,
      meta,
      metaRealizada,
      dataGrafico,
      totalClientesAtendidos,
      totalClientes,
      porcentagemAtendidos,
    });
  }

  iniciaChartCarteiraClientes() {
    let chart = am4core.create("chartdiv", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0;

    chart.data = this.state.dataGraficoCarteiraClientes;
    chart.radius = am4core.percent(70);
    chart.innerRadius = am4core.percent(40);
    chart.startAngle = 180;
    chart.endAngle = 360;
    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "type";
    series.slices.template.cornerRadius = 10;
    series.slices.template.innerCornerRadius = 7;
    series.slices.template.draggable = true;
    series.slices.template.inert = true;
    series.alignLabels = false;
    series.hiddenState.properties.startAngle = 90;
    series.hiddenState.properties.endAngle = 90;
    series.labels.template.disabled = true;
    chart.legend = new am4charts.Legend();

    series.slices.template.propertyFields.fill = "color";

    series.slices.template.events.on(
      "hit",
      function (ev) {
        this.props.history.push("/carteira-clientes");
      },
      this
    );

    this.chart = chart;
  }

  iniciaGraficoMeta() {
    let chart2 = am4core.create("chartdiv2", am4charts.GaugeChart);
    chart2.innerRadius = am4core.percent(82);

    let axis = chart2.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.renderer.radius = am4core.percent(80);
    axis.renderer.inside = true;
    axis.renderer.line.strokeOpacity = 1;
    axis.renderer.ticks.template.disabled = false;
    axis.renderer.ticks.template.strokeOpacity = 1;
    axis.renderer.ticks.template.length = 10;
    axis.renderer.grid.template.disabled = true;
    axis.renderer.labels.template.radius = 40;
    axis.renderer.labels.template.adapter.add("text", function (text) {
      return text + "%";
    });

    /**
     * Axis for ranges
     */

    let axis2 = chart2.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;

    let range0 = axis2.axisRanges.create();
    range0.value = 0;
    range0.endValue = 50;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = am4core.color("#309A85");

    let range1 = axis2.axisRanges.create();
    range1.value = 50;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color("#e0d9d9");

    /**
     * Label
     */

    let label = chart2.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 40;
    label.x = am4core.percent(50);
    label.y = am4core.percent(100);
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    label.text = "50%";

    /**
     * Hand
     */

    let hand = chart2.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(20);
    hand.startWidth = 10;
    hand.pin.disabled = true;
    hand.value = this.state.porcentagemGraficoMeta;

    hand.events.on("propertychanged", function (ev) {
      range0.endValue = ev.target.value;
      range1.value = ev.target.value;
      label.text = axis2.positionToValue(hand.currentPosition).toFixed(1);
      axis2.invalidate();
    });

    this.chart2 = chart2;
  }

  iniciaGraficoPedidos() {
    let chart3 = am4core.create("chartdiv3", am4charts.XYChart);
    chart3.data = this.state.dataGraficoPedidos;

    chart3.padding(40, 40, 40, 40);

    let categoryAxis = chart3.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "month";
    categoryAxis.renderer.minGridDistance = 60;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.disabled = true;

    let valueAxis = chart3.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.extraMax = 0.1;
    //valueAxis.rangeChangeEasing = am4core.ease.linear;
    //valueAxis.rangeChangeDuration = 1500;

    let series = chart3.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryX = "month";
    series.dataFields.valueY = "value";
    series.tooltipText = "{valueY.value}";
    series.columns.template.strokeOpacity = 0;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.cornerRadiusTopLeft = 10;
    //series.interpolationDuration = 1500;
    //series.interpolationEasing = am4core.ease.linear;
    let labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.verticalCenter = "bottom";
    labelBullet.label.dy = -10;
    // labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";
    labelBullet.label.text =
      "{values.valueY.workingValue.formatNumber('R$ #,###.00')}";

    chart3.zoomOutButton.disabled = true;

    // as by default columns of the same series are of the same color, we add adapter which takes colors from chart3.colors color set
    series.columns.template.adapter.add("fill", function (fill, target) {
      return "#309A85";
    });

    // setInterval(function () {
    //   am4core.array.each(chart3.data, function (item) {
    //     item.value += Math.round(Math.random() * 200 - 100);
    //     item.value = Math.abs(item.value);
    //   });
    //   chart3.invalidateRawData();
    // }, 2000);

    series.columns.template.events.on(
      "hit",
      function (ev) {
        let dataAtual = "";
        let mes = ev.target.dataItem.categories.categoryX;

        for (let item of this.state.dataGraficoPedidos) {
          if (item.month === mes) {
            dataAtual = item.data;
          }
        }

        this.props.history.push(`/pedidos?data=${dataAtual}`);
      },
      this
    );

    categoryAxis.sortBySeries = series;
    this.chart3 = chart3;
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container-scroller font-app">
          <NavBar title="Dashboard" />

          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"dashboard"} />

            <div className="main-panel">
              <div className="content-wrapper" style={{ marginBottom: "40px" }}>
                {/* <TitleAndDescription
                  title="Dashboard"
                  description="Indicadores referentes ao seu desempenho."
                /> */}
                <div className="row">
                  <div className="col-md-12 grid-margin-box stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <ul className="nav nav-tabs px-4" role="tablist">
                          <li className="nav-item">
                            <a
                              className={`nav-link ${
                                this.state.abaAtiva === "pedido" ? "active" : ""
                              }`}
                              onClick={() => this.toggleAba("pedido")}
                              style={{ cursor: "pointer" }}
                            >
                              Pedidos
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${
                                this.state.abaAtiva === "orcamento"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => this.toggleAba("orcamento")}
                              style={{ cursor: "pointer" }}
                            >
                              Orçamentos
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content py-0 px-0">
                          {this.state.abaAtiva === "pedido" && (
                            <div className="tab-pane fade show active">
                              <div className="d-flex flex-wrap justify-content-xl-between">
                                <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <img
                                    src="images/calendar.png"
                                    alt="logo"
                                    className="mr-3 mx-3"
                                    style={{ width: "28px" }}
                                  />
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Período
                                    </small>
                                    <div className="dropdown">
                                      <select
                                        className="no-border"
                                        style={{ fontWeight: "bold" }}
                                        value={this.state.periodoPedido}
                                        onChange={(e) =>
                                          this.onChangePeriodoPedido(e)
                                        }
                                      >
                                        <option value="mesAtual">
                                          Mês Atual
                                        </option>
                                        <option value="mesAnterior">
                                          Mês Anterior
                                        </option>
                                      </select>
                                      <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuLinkA"
                                      >
                                        <a className="dropdown-item" href="#">
                                          Mês anterior
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <span className="simbolo-dinheiro">R$</span>

                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Total de pedidos
                                    </small>
                                    <h5 className="mr-2 mb-0">
                                      {formatarReal(
                                        this.state.valorTotalPedido
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <span className="simbolo-dinheiro">R$</span>
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Ticket Médio
                                    </small>
                                    <h5 className="mr-2 mb-0">
                                      {formatarReal(
                                        this.state.ticketMedioPedidos
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <img
                                    src="images/trash.png"
                                    alt="logo"
                                    className="mr-3 mx-3"
                                    style={{ width: "25px" }}
                                  />
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Cancelados
                                    </small>
                                    <h5 className="mr-2 mb-0">0</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {this.state.abaAtiva === "orcamento" && (
                            <div className="tab-pane fade show active">
                              <div className="d-flex flex-wrap justify-content-xl-between">
                                <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <img
                                    src="images/calendar.png"
                                    alt="logo"
                                    className="mr-3 mx-3"
                                    style={{ width: "28px" }}
                                  />
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Período
                                    </small>
                                    <div className="dropdown">
                                      <select
                                        className="no-border"
                                        style={{ fontWeight: "bold" }}
                                        value={this.state.periodoOrcamento}
                                        onChange={(e) =>
                                          this.onChangePeriodoOrcamento(e)
                                        }
                                      >
                                        <option value="mesAtual">
                                          Mês Atual
                                        </option>
                                        <option value="mesAnterior">
                                          Mês Anterior
                                        </option>
                                      </select>
                                      <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuLinkA"
                                      >
                                        <a className="dropdown-item" href="#">
                                          Mês anterior
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <span className="simbolo-dinheiro">R$</span>
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Total de orçamentos
                                    </small>
                                    <h5 className="mr-2 mb-0">
                                      {formatarReal(
                                        this.state.valorTotalOrcamento
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <span className="simbolo-dinheiro">R$</span>
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Ticket Médio
                                    </small>
                                    <h5 className="mr-2 mb-0">
                                      {formatarReal(
                                        this.state.ticketMedioOrcamentos
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                  <img
                                    src="images/trash.png"
                                    alt="logo"
                                    className="mr-3 mx-3"
                                    style={{ width: "25px" }}
                                  />
                                  <div className="d-flex flex-column justify-content-around">
                                    <small className="mb-1 text-muted">
                                      Cancelados
                                    </small>
                                    <h5 className="mr-2 mb-0">
                                      {this.state.totalOrcamentosCancelados}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-wrap">
                  <div className="col-7" style={{ padding: "0 5px" }}>
                    <div
                      style={{ backgroundColor: "#FFF", minHeight: "370px" }}
                    >
                      <div className="font-box">Carteira de clientes</div>
                      <div style={{ padding: "0 10px" }}>
                        <div
                          id="chartdiv"
                          style={{ width: "100%", height: "300px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-5" style={{ padding: "0 5px" }}>
                    <div
                      style={{ backgroundColor: "#FFF", minHeight: "370px" }}
                    >
                      <div className="font-box text-center">
                        Meta Mensal - {this.state.periodo}
                        <br />
                        Meta: R$ {formatarReal(this.state.meta)} - Realizada: R${" "}
                        {formatarReal(this.state.metaRealizada)}
                      </div>
                      <div>
                        <div
                          id="chartdiv2"
                          style={{ width: "100%", height: "300px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="d-flex flex-wrap" style={{ marginTop: "10px" }}>
                  <div className="col-12" style={{ padding: "0 5px" }}>
                    <div style={{ backgroundColor: "#FFF" }}>
                      <div className="font-box">
                        Pedidos dos últimos 6 meses
                      </div>
                      <div style={{ padding: "0 10px" }}>
                        <div
                          id="chartdiv3"
                          style={{ width: "100%", height: "350px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div
                  className="row"
                  style={{
                    marginLeft: "0px",
                    paddingRight: "15px",
                    paddingTop: "14px",
                  }}
                >
                  {this.state.exibirGraficoMeta && (
                    <div
                      className="col-md-6"
                      style={{
                        backgroundColor: "#FFF",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="col-md-10 box-graficos"
                        style={{
                          backgroundColor: "#FFF",
                        }}
                      >
                        <React.Fragment>
                          <div className="titulo-grafico">
                            Meta Mensal - {this.state.periodo}
                          </div>
                          <div className="subtitulo-grafico">
                            R$ {formatarReal(this.state.meta)}
                          </div>
                          <div
                            className="subtitulo-grafico"
                            style={{ paddingBottom: "15px" }}
                          >
                            Realizada: R${" "}
                            {formatarReal(this.state.metaRealizada)}
                          </div>

                          <Doughnut
                            data={this.state.optionsGrafico}
                            width={95}
                            height={45}
                            options={{
                              legend: {
                                display: true,
                                position: "bottom",
                              },
                            }}
                          />
                        </React.Fragment>
                      </div>
                    </div>
                  )}

                  <div
                    className="col-md-6 box-graficos"
                    style={{
                      backgroundColor: "#FFF",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="col-md-10 box-graficos"
                      style={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      <React.Fragment>
                        <div className="titulo-grafico">
                          Pedidos dos últimos 6 meses
                        </div>

                        <Bar
                          data={this.state.dataGrafico}
                          width={100}
                          height={250}
                          options={{
                            maintainAspectRatio: false,
                            legend: {
                              position: "bottom",
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: true,
                                  },
                                },
                              ],
                            },
                          }}
                        />
                      </React.Fragment>
                    </div>
                  </div>
                </div> */}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
